import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import './global.css'
import '@fontsource/material-symbols-outlined/400.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

// Ждем загрузки всех шрифтов перед показом иконок
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
        document.documentElement.classList.add('fonts-loaded');
        document.body.classList.add('fonts-loaded');
    });
} else {
    // Fallback для браузеров без Font Loading API
    window.addEventListener('load', () => {
        setTimeout(() => {
            document.documentElement.classList.add('fonts-loaded');
            document.body.classList.add('fonts-loaded');
        }, 100);
    });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
      <BrowserRouter>
          <App />
      </BrowserRouter>
  </React.StrictMode>
);

// Скрываем статический спиннер после монтирования React
const loader = document.getElementById('initial-loader');
if (loader) {
    loader.classList.add('hidden');
}

